'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { useNavigationGroupList } from '@/app/donation/_hooks/useNavigationGroupList';
import { useAuthStore } from '@/stores/AuthStore';
export const NavigationArea = t0 => {
  const $ = _c(10);
  const {
    className
  } = t0;
  const isLogin = useAuthStore(_temp) ?? false;
  const {
    navigationGroupList
  } = useNavigationGroupList();
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-24 pb-80", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isLogin || $[3] !== navigationGroupList) {
    let t3;
    if ($[5] !== isLogin) {
      t3 = group => <li key={group.label} className="flex flex-col gap-18 border-b border-Gray-100 px-16 pb-30 pt-24 last-of-type:border-b-0"><p className="font-600 text-Gray-600 typo-caption1">{group.label}</p><ul className="flex flex-col gap-24">{group.items.map(item => {
            const isLoginRequiredBadgeShow = isLogin === false && item.isLoginRequired;
            const content = <>{item.icon}<p className="font-500 text-Gray-900 typo-body3">{item.label}</p>{item.isNew ? <div className="absolute -right-10 top-0 size-6 rounded-pill bg-R-400" /> : null}</>;
            return <li key={item.label} className="flex items-center justify-between">{item.onClick ? <button type="button" className="relative flex w-fit items-center gap-8" onClick={item.onClick}>{content}</button> : <CustomLink className="relative flex w-fit items-center gap-8" href={item.href} aria-label={`${item.label} 페이지로 이동`}>{content}</CustomLink>}{isLoginRequiredBadgeShow ? <button type="button" className="whitespace-nowrap rounded-small border-1 border-B-500 px-8 py-2 font-600 text-B-500 typo-caption1">로그인필요</button> : null}</li>;
          })}</ul></li>;
      $[5] = isLogin;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = navigationGroupList.map(t3);
    $[2] = isLogin;
    $[3] = navigationGroupList;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <ul className={t1}>{t2}</ul>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(state) {
  return state.isLogin;
}